import { Serializable } from './serializable';

export enum SEND_AMOUNT_TYPE {
  SEND = 1,
  SURCHARGE = 2,
  PAYOUT = 3
}

export enum SEND_AMOUNT_TYPE_NEW_ORDER {
  SEND = 1,
  SURCHARGE = 3,
  PAYOUT = 2
}

export class TransactionPreview extends Serializable {
  public BankAccountNo: number;
  public ResponseID: number;
  public CustomerName: string;
  public CustomerAddress: string;
  public CustomerAddressUnitNumber: number;
  public CustomerCity: string;
  public CustomerState: string;
  public CustomerPostalCode: string;
  public CustomerCountry: string;
  public CustomerTelNo: string;
  public BeneficiaryName: string;
  public BeneficiaryAddress: string;
  public BeneficiaryCity: string;
  public BeneficiaryState: string;
  public BeneficiaryPostalCode: string;
  public BeneficiaryCountry: string;
  public PayoutCorrespName: string;
  public PayoutCorrespNo: string;
  public PayoutLocAddress1: string;
  public PayoutCountry: string;
  public PayoutMethod: string;
  public PayoutLocName: string;
  public PromocodeFee: number;
  public PromoAmount: number;
  public SendCurrency: string;
  public SendAmount: string;
  public CustomerFee: number;
  public Surcharge: number;
  public Tax: number;
  public TotalAmount: string;
  public ExchangeRate: number;
  public PayoutCurrency: string;
  public PayoutAmount: string;
  public Reason: number;
  public DecimalsMonetaryFrom: number;
  public DecimalsMonetaryTo: number;
  public OriginalCustomerFee: number;
  public TransIdLocked: number;
  public PromoCode: string;
  public PromoId: string;
  public RetVal: number;
  public RetMsg: string;
  public ShowRateInverted: boolean;
  public CustomerRateDecimal: number;
  public CustomerInvertedRateDecimal: number;
  public ProvidedFields: any;
  public IsPromoValid: boolean;
  public SplitCurrency1: string;
  public SplitCurrency2: string;
  public SplitExchangeRate1: number;
  public SplitExchangeRate2: number;
  public SplitReceiveAmount1: number;
  public SplitReceiveAmount2: number;
  public SendAmountLimitsResponse: {
    MaximumSendFromAmount: number,
    MinimumSendFromAmount:number
  };
}



// WEBPACK FOOTER //
// ./src/model/myria/app/transactionPreview.ts